import { HandheldAppVersionInfoService, NakiHandheldBetaChannelService } from "common/services";
import AppReleaseRouteStore from "./AppReleaseRouteStore";

class HandheldAppReleaseRouteStore extends AppReleaseRouteStore {
    constructor(rootStore) {
        super(rootStore, HandheldAppVersionInfoService, NakiHandheldBetaChannelService);
    }
}

export default HandheldAppReleaseRouteStore;
